/*
 * @Author: YuanYuan
 * @Date: 2025-01-21 11:28:11
 * @LastEditTime: 2026-02-06 09:56:22
 * @Description: 路由配置
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { clearConfirmData } from '@/views/purchase/func'
import { isInMenuList, toModuleFirstMenu, getCurrentUser } from '@/utils/base'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes
})

const purchasePages = [
  '/floodShield/tryout',
  '/floodShield/cs',
  '/iplc',
  '/aps'
]

// 直接从官网或者后管跳转到指定的路由
const directUrls = [
  '/domainManage',
  '/document/help'
]

router.beforeEach((to, from, next) => {
  document.title = to?.meta?.title ? to.meta.title + ' - CDNetworks' : 'CDNetworks'
  if (!getCurrentUser() && directUrls.includes(to.path)) {
    store.commit('csec/SET_LOGIN_NEXT_ROUTE', to.path)
    next('/login')
  }
  if (to.meta.leftMenuCode) {
    if (process.env.NODE_ENV === 'production') {
      if (isInMenuList(to)) {
        next()
      } else {
        toModuleFirstMenu()
        window.location.reload()
      }
    } else {
      next()
    }
    clearConfirmData()
  } else {
    if (!store.state.csec.loginNextRoute) {
      // 购买页面
      if(from.path === '/') {
        // 原地刷新
        if (purchasePages.includes(to.path)) {
          clearConfirmData()
        }
      } else {
        if (from.path === '/floodShield/tryout') {
          if (to.path !== '/purchase/confirm') {
            clearConfirmData()
          }
        }
        if (from.path === '/floodShield/cs') {
          if (to.path !== '/purchase/confirm') {
            clearConfirmData()
          }
        }
        if (from.path === '/iplc') {
          if (to.path !== '/purchase/confirm') {
            clearConfirmData()
          }
        }
        if (from.path === '/purchase/confirm') {
          if (!purchasePages.includes(to.path)) {
            clearConfirmData()
          }
        }
      }
    }
    next()
  }
})

export default router
